import { Environment } from "react-relay";
import { LoaderFunction, RouteObject } from "react-router";
import {
  RouteObjectModule,
  routes,
  type RouteObject as BuildRoute,
} from "@aqora-io/react-router";
import ErrorPage from "@/pages/_error";
import Loader from "./Loader";

type PageLoader = (environment: Environment) => LoaderFunction;

export default function buildRoutes(environment: Environment): RouteObject[] {
  const lazyRoute = (module: RouteObjectModule) => async () => {
    const {
      default: Component,
      loader: loader0,
      ...route
    } = await module.resolve();
    const loader = (loader0 as PageLoader | undefined)?.(environment);
    return { Component, loader, ...route };
  };

  function rec(routes: BuildRoute[]): RouteObject[] {
    return routes.map(
      ({ module, children, ...route }) =>
        ({
          ...route,
          handle: module && { module: module.name },
          lazy: module && lazyRoute(module),
          children: children && rec(children),
          ErrorBoundary: ErrorPage,
          HydrateFallback: Loader,
        }) as RouteObject,
    );
  }

  // return [
  //   {
  //     children: rec(routes),
  //     ErrorBoundary: ErrorPage,
  //     HydrateFallback: Loader,
  //   },
  // ];
  return rec(routes);
}
